var _rect, _rect2, _g, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnAssessment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 846,
    transform: "translate(-120 -603)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_565_12442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM6.66667 14.1667C6.20833 14.1667 5.83333 13.7917 5.83333 13.3333V9.16667C5.83333 8.70833 6.20833 8.33333 6.66667 8.33333C7.125 8.33333 7.5 8.70833 7.5 9.16667V13.3333C7.5 13.7917 7.125 14.1667 6.66667 14.1667ZM10 14.1667C9.54167 14.1667 9.16667 13.7917 9.16667 13.3333V6.66667C9.16667 6.20833 9.54167 5.83333 10 5.83333C10.4583 5.83333 10.8333 6.20833 10.8333 6.66667V13.3333C10.8333 13.7917 10.4583 14.1667 10 14.1667ZM13.3333 14.1667C12.875 14.1667 12.5 13.7917 12.5 13.3333V11.6667C12.5 11.2083 12.875 10.8333 13.3333 10.8333C13.7917 10.8333 14.1667 11.2083 14.1667 11.6667V13.3333C14.1667 13.7917 13.7917 14.1667 13.3333 14.1667Z",
    fill: "#2E2B2E"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -19.5,
    y: -387.5,
    width: 379,
    height: 530,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_565_12442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnAssessment);
export default __webpack_public_path__ + "static/media/icn_assessment.e9f98bd89a39bce32fc6a3e4d7bcbc53.svg";
export { ForwardRef as ReactComponent };